import type { AuthorizedPerson, Cart } from '@/modules/cart/domain/Cart';
import type { CartRepository } from '@/modules/cart/domain/CartRepository';
import type { IdentificationDocumentType } from '@/modules/shared/types/IdentificationDocumentType';

const setOnBehalf = (
  repository: CartRepository,
  deliveryGroupId: string,
  authorizedPerson: AuthorizedPerson,
  customerDocumentInfo?: {
    documentType?: IdentificationDocumentType;
    documentID?: string;
    customerRut?: string;
  },
  isRegisteredUser: boolean = false
): Promise<Cart> => {
  return repository.setOnBehalf(
    deliveryGroupId,
    authorizedPerson,
    customerDocumentInfo,
    isRegisteredUser
  );
};

export default setOnBehalf;
